import { useEffect, useState } from 'react'
import { Flex, Text, Alert, AlertIcon, AlertDescription, Button } from '@chakra-ui/react'
import { getDifferenceInHoursBetweenHours } from 'utils/calculations'
import { Plus } from 'components/icons'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function RegistroDeHoraExtra() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch, setValue } = formMethods
  const [periodo1Status, setPeriodo1Status] = useState(false)

  const [periodo2Status, setPeriodo2Status] = useState(false)
  const [periodo2Visibility, setPeriodo2Visibility] = useState(false)

  const [periodo3Status, setPeriodo3Status] = useState(false)
  const [periodo3Visibility, setPeriodo3Visibility] = useState(false)

  const [periodo4Status, setPeriodo4Status] = useState(false)
  const [periodo4Visibility, setPeriodo4Visibility] = useState(false)

  const [periodo5Status, setPeriodo5Status] = useState(false)
  const [periodo5Visibility, setPeriodo5Visibility] = useState(false)

  const [periodo6Status, setPeriodo6Status] = useState(false)
  const [periodo6Visibility, setPeriodo6Visibility] = useState(false)

  function isValidHour(horario: string) {
    return /^\d{2}:\d{2}$/.test(horario)
  }

  function isValidDate(date: string) {
    // Verifica o formato dd/mm/yyyy
    const regex = /^\d{2}\/\d{2}\/\d{4}$/
    if (!regex.test(date)) return false

    const [diaStr, mesStr, anoStr] = date.split('/')
    const dia = parseInt(diaStr, 10)
    const mes = parseInt(mesStr, 10)
    const ano = parseInt(anoStr, 10)

    // O JavaScript conta os meses de 0 (jan) a 11 (dez), por isso subtrai 1
    const data = new Date(ano, mes - 1, dia)

    return data.getFullYear() === ano && data.getMonth() === mes - 1 && data.getDate() === dia
  }

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  //PERIODO 1
  const periodo1Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 1 - Início da hora extra']}`)
    : undefined
  const periodo1Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 1 - Fim da hora extra']}`) : undefined
  //PERIODO 2
  const periodo2Data = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 2 - Data de realização da hora extra']}`)
    : undefined
  const periodo2Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 2 - Início da hora extra']}`)
    : undefined
  const periodo2Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 2 - Fim da hora extra']}`) : undefined
  //PERIODO 3
  const periodo3Data = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 3 - Data de realização da hora extra']}`)
    : undefined
  const periodo3Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 3 - Início da hora extra']}`)
    : undefined
  const periodo3Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 3 - Fim da hora extra']}`) : undefined
  //PERIODO 4
  const periodo4Data = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 4 - Data de realização da hora extra']}`)
    : undefined
  const periodo4Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 4 - Início da hora extra']}`)
    : undefined
  const periodo4Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 4 - Fim da hora extra']}`) : undefined
  //PERIODO 5
  const periodo5Data = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 5 - Data de realização da hora extra']}`)
    : undefined
  const periodo5Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 5 - Início da hora extra']}`)
    : undefined
  const periodo5Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 5 - Fim da hora extra']}`) : undefined
  //PERIODO 6
  const periodo6Data = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 6 - Data de realização da hora extra']}`)
    : undefined
  const periodo6Inicio = watch
    ? watch(`form_answers.${titleForQuestion['PERÍODO 6 - Início da hora extra']}`)
    : undefined
  const periodo6Fim = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 6 - Fim da hora extra']}`) : undefined

  //PERIODO 1
  useEffect(() => {
    if (periodo1Inicio && periodo1Fim) {
      if (isValidHour(periodo1Inicio) && isValidHour(periodo1Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo1Inicio, finalHour: periodo1Fim })
        if (result <= 2) {
          setPeriodo1Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 1 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 1 - Duração']}`, '')
          setPeriodo1Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 1 - Duração']}`, '')
        setPeriodo1Status(false)
      }
    } else {
      setPeriodo1Status(false)
    }
  }, [periodo1Inicio, periodo1Fim, setValue])

  //PERIODO 2
  useEffect(() => {
    if (!isValidDate(periodo2Data)) {
      setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Início da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Fim da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Duração']}`, '')
    }
    if (periodo2Inicio && periodo2Fim) {
      if (isValidHour(periodo2Inicio) && isValidHour(periodo2Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo2Inicio, finalHour: periodo2Fim })
        if (result <= 2) {
          setPeriodo2Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Duração']}`, '')
          setPeriodo2Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 2 - Duração']}`, '')
        setPeriodo2Status(false)
      }
    } else {
      setPeriodo2Status(false)
    }
  }, [periodo2Data, periodo2Inicio, periodo2Fim, setValue])

  //PERIODO 3
  useEffect(() => {
    if (!isValidDate(periodo3Data)) {
      setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Início da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Fim da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Duração']}`, '')
    }
    if (periodo3Inicio && periodo3Fim) {
      if (isValidHour(periodo3Inicio) && isValidHour(periodo3Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo3Inicio, finalHour: periodo3Fim })
        if (result <= 2) {
          setPeriodo3Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Duração']}`, '')
          setPeriodo3Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 3 - Duração']}`, '')
        setPeriodo3Status(false)
      }
    } else {
      setPeriodo3Status(false)
    }
  }, [periodo3Data, periodo3Inicio, periodo3Fim, setValue])

  //PERIODO 4
  useEffect(() => {
    if (!isValidDate(periodo4Data)) {
      setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Início da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Fim da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Duração']}`, '')
    }
    if (periodo4Inicio && periodo4Fim) {
      if (isValidHour(periodo4Inicio) && isValidHour(periodo4Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo4Inicio, finalHour: periodo4Fim })
        if (result <= 2) {
          setPeriodo4Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Duração']}`, '')
          setPeriodo4Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 4 - Duração']}`, '')
        setPeriodo4Status(false)
      }
    } else {
      setPeriodo4Status(false)
    }
  }, [periodo4Data, periodo4Inicio, periodo4Fim, setValue])

  //PERIODO 5
  useEffect(() => {
    if (!isValidDate(periodo5Data)) {
      setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Início da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Fim da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Duração']}`, '')
    }
    if (periodo5Inicio && periodo5Fim) {
      if (isValidHour(periodo5Inicio) && isValidHour(periodo5Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo5Inicio, finalHour: periodo5Fim })
        if (result <= 2) {
          setPeriodo5Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Duração']}`, '')
          setPeriodo5Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 5 - Duração']}`, '')
        setPeriodo5Status(false)
      }
    } else {
      setPeriodo5Status(false)
    }
  }, [periodo5Data, periodo5Inicio, periodo5Fim, setValue])

  //PERIODO 6
  useEffect(() => {
    if (!isValidDate(periodo6Data)) {
      setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Início da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Fim da hora extra']}`, '')
      setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Duração']}`, '')
    }
    if (periodo6Inicio && periodo6Fim) {
      if (isValidHour(periodo6Inicio) && isValidHour(periodo6Fim)) {
        const result = getDifferenceInHoursBetweenHours({ startTime: periodo6Inicio, finalHour: periodo6Fim })
        if (result <= 2) {
          setPeriodo6Status(false)
          setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Duração']}`, result.toFixed(2))
        } else {
          setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Duração']}`, '')
          setPeriodo6Status(true)
        }
      } else {
        setValue(`form_answers.${titleForQuestion['PERÍODO 6 - Duração']}`, '')
        setPeriodo6Status(false)
      }
    } else {
      setPeriodo6Status(false)
    }
  }, [periodo6Data, periodo6Inicio, periodo6Fim, setValue])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        const questionAboutPeriod = question.title?.includes('PERÍODO')
        const match = question.title?.match(/PERÍODO (\d+) -/)
        let number = null

        if (questionAboutPeriod) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        //PERIODO 1
        if (question.title == 'PERÍODO 1 - Duração') {
          return (
            <Flex
              key={question.id}
              w="full"
              flexDir={'column'}
              border={periodo1Status ? '1px solid' : 'none'}
              borderColor={'red.500'}
              rounded={'md'}
            >
              <CustomFormViewerQuestion
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={true}
              />
              {periodo1Status && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Limite máximo atingido</AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //PERIODO 2
        if (number == 2 && !periodo2Visibility) {
          if (question.title == 'PERÍODO 2 - Data de realização da hora extra') {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo2Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 2
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 2) {
          if (question.title == 'PERÍODO 2 - Data de realização da hora extra') {
            return (
              <Flex key={question.id} w="full" flexDir={'column'}>
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={false}
                />
                {periodo2Data?.length == 10 && !isValidDate(periodo2Data) && (
                  <Text color="red.500" ml={2}>
                    Data inválida
                  </Text>
                )}
              </Flex>
            )
          }
          if (
            question.title == 'PERÍODO 2 - Início da hora extra' ||
            question.title == 'PERÍODO 2 - Fim da hora extra' ||
            question.title == 'PERÍODO 2 - Duração'
          ) {
            if (!isValidDate(periodo2Data)) {
              return <></>
            }
          }
          if (question.title == 'PERÍODO 2 - Duração') {
            return (
              <Flex
                key={question.id}
                w="full"
                flexDir={'column'}
                border={periodo2Status ? '1px solid' : 'none'}
                borderColor={'red.500'}
                rounded={'md'}
              >
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={true}
                />
                {periodo2Status && (
                  <Alert status="error" rounded={'md'}>
                    <AlertIcon />
                    <AlertDescription>Limite máximo atingido</AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          }
        }

        //PERIODO 3
        if (number == 3 && !periodo3Visibility) {
          if (question.title == 'PERÍODO 3 - Data de realização da hora extra' && periodo2Visibility) {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo3Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 3
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 3) {
          if (question.title == 'PERÍODO 3 - Data de realização da hora extra') {
            return (
              <Flex key={question.id} w="full" flexDir={'column'}>
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={false}
                />
                {periodo3Data?.length == 10 && !isValidDate(periodo3Data) && (
                  <Text color="red.500" ml={2}>
                    Data inválida
                  </Text>
                )}
              </Flex>
            )
          }
          if (
            question.title == 'PERÍODO 3 - Início da hora extra' ||
            question.title == 'PERÍODO 3 - Fim da hora extra' ||
            question.title == 'PERÍODO 3 - Duração'
          ) {
            if (!isValidDate(periodo3Data)) {
              return <></>
            }
          }
          if (question.title == 'PERÍODO 3 - Duração') {
            return (
              <Flex
                key={question.id}
                w="full"
                flexDir={'column'}
                border={periodo3Status ? '1px solid' : 'none'}
                borderColor={'red.500'}
                rounded={'md'}
              >
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={true}
                />
                {periodo3Status && (
                  <Alert status="error" rounded={'md'}>
                    <AlertIcon />
                    <AlertDescription>Limite máximo atingido</AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          }
        }

        //PERIODO 4
        if (number == 4 && !periodo4Visibility) {
          if (question.title == 'PERÍODO 4 - Data de realização da hora extra' && periodo3Visibility) {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo4Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 4
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 4) {
          if (question.title == 'PERÍODO 4 - Data de realização da hora extra') {
            return (
              <Flex key={question.id} w="full" flexDir={'column'}>
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={false}
                />
                {periodo4Data?.length == 10 && !isValidDate(periodo4Data) && (
                  <Text color="red.500" ml={2}>
                    Data inválida
                  </Text>
                )}
              </Flex>
            )
          }
          if (
            question.title == 'PERÍODO 4 - Início da hora extra' ||
            question.title == 'PERÍODO 4 - Fim da hora extra' ||
            question.title == 'PERÍODO 4 - Duração'
          ) {
            if (!isValidDate(periodo4Data)) {
              return <></>
            }
          }
          if (question.title == 'PERÍODO 4 - Duração') {
            return (
              <Flex
                key={question.id}
                w="full"
                flexDir={'column'}
                border={periodo4Status ? '1px solid' : 'none'}
                borderColor={'red.500'}
                rounded={'md'}
              >
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={true}
                />
                {periodo4Status && (
                  <Alert status="error" rounded={'md'}>
                    <AlertIcon />
                    <AlertDescription>Limite máximo atingido</AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          }
        }

        //PERIODO 5
        if (number == 5 && !periodo5Visibility) {
          if (question.title == 'PERÍODO 5 - Data de realização da hora extra' && periodo4Visibility) {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo5Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 5
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 5) {
          if (question.title == 'PERÍODO 5 - Data de realização da hora extra') {
            return (
              <Flex key={question.id} w="full" flexDir={'column'}>
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={false}
                />
                {periodo5Data?.length == 10 && !isValidDate(periodo5Data) && (
                  <Text color="red.500" ml={2}>
                    Data inválida
                  </Text>
                )}
              </Flex>
            )
          }
          if (
            question.title == 'PERÍODO 5 - Início da hora extra' ||
            question.title == 'PERÍODO 5 - Fim da hora extra' ||
            question.title == 'PERÍODO 5 - Duração'
          ) {
            if (!isValidDate(periodo5Data)) {
              return <></>
            }
          }
          if (question.title == 'PERÍODO 5 - Duração') {
            return (
              <Flex
                key={question.id}
                w="full"
                flexDir={'column'}
                border={periodo5Status ? '1px solid' : 'none'}
                borderColor={'red.500'}
                rounded={'md'}
              >
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={true}
                />
                {periodo5Status && (
                  <Alert status="error" rounded={'md'}>
                    <AlertIcon />
                    <AlertDescription>Limite máximo atingido</AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          }
        }

        //PERIODO 6
        if (number == 6 && !periodo6Visibility) {
          if (question.title == 'PERÍODO 6 - Data de realização da hora extra' && periodo5Visibility) {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo6Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 6
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 6) {
          if (question.title == 'PERÍODO 6 - Data de realização da hora extra') {
            return (
              <Flex key={question.id} w="full" flexDir={'column'}>
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={false}
                />
                {periodo6Data?.length == 10 && !isValidDate(periodo6Data) && (
                  <Text color="red.500" ml={2}>
                    Data inválida
                  </Text>
                )}
              </Flex>
            )
          }
          if (
            question.title == 'PERÍODO 6 - Início da hora extra' ||
            question.title == 'PERÍODO 6 - Fim da hora extra' ||
            question.title == 'PERÍODO 6 - Duração'
          ) {
            if (!isValidDate(periodo6Data)) {
              return <></>
            }
          }
          if (question.title == 'PERÍODO 6 - Duração') {
            return (
              <Flex
                key={question.id}
                w="full"
                flexDir={'column'}
                border={periodo6Status ? '1px solid' : 'none'}
                borderColor={'red.500'}
                rounded={'md'}
              >
                <CustomFormViewerQuestion
                  question={question}
                  index={index}
                  questionsLength={questions?.length}
                  disabled={true}
                />
                {periodo6Status && (
                  <Alert status="error" rounded={'md'}>
                    <AlertIcon />
                    <AlertDescription>Limite máximo atingido</AlertDescription>
                  </Alert>
                )}
              </Flex>
            )
          }
        }
        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
